import type { DemandeDTO, ModelDemande } from '@/features/api/extranet/dto/Demande/shared'
import type { ModelDemandeLov } from '@/features/api/extranet/dto/Demande/shared/ModelDemandeLov.ts'
import type { LovDTO } from '@/features/api/extranet/dto/Lov'
import type { ErreurSummaryConfiguration } from '@/features/application/erreur-summary'
import type { DemandeActions, DemandeStore, UseDemandeStore } from '@/features/interface/demande/shared'
import type { Component, InjectionKey, Ref } from 'vue'

export type SetupDemande<TModelDemande extends ModelDemande, TTabs extends string = any> = {
  useStore: UseDemandeStore<TModelDemande>
  injectActions: (store: DemandeStore<TModelDemande, ModelDemandeLov<TModelDemande>>) => DemandeActions
  tabFirst: TTabs
  tabsVue: Record<TTabs, Component>
  tabsErrorConfig: (
    store: DemandeStore<TModelDemande, ModelDemandeLov<TModelDemande>>,
  ) => ErreurSummaryConfiguration<DemandeDTO<TModelDemande>>
  customizeNatureFichiers?: (store: DemandeStore<TModelDemande, ModelDemandeLov<TModelDemande>>) => LovDTO<string>
  onInitialize?: (store: DemandeStore<TModelDemande, ModelDemandeLov<TModelDemande>>, actions: DemandeActions) => void | (() => void)
}

export type DemandeContentStore = {
  getStore<TModelDemande extends ModelDemande = ModelDemande>():
    DemandeStore<TModelDemande, ModelDemandeLov<TModelDemande>>
  currentStep: Ref<string>
}

export const DEMANDE_STORE: InjectionKey<DemandeContentStore> = Symbol('demande-store')
